/**
 * This module exports a require 'context', which is a WebPack artifact that allows
 * dynamically loading files from a given directory. This happens at build time, producing
 * inlining all the loaded files in the final bundle.
 * More info about this at https://webpack.js.org/guides/dependency-management/#require-context
 */

const context = require.context('./locale', true, /\.json$/);

export default context;



// WEBPACK FOOTER //
// ./src/translations/context.js